"use client";

import {useState} from 'react';

const useDiningForm = () => {
  const [values, setValues] = useState({
    fullname: '',
    email: '',
    phoneno: '',
    message: '',
  });

  const handleChange = (e) => {
    setValues(prevState => {
      return {
        ...prevState,
        [e.target.id]: e.target.value,
      };
    });
  };

  return {values, handleChange};
};

export default useDiningForm;